// extracted by mini-css-extract-plugin
export default {"user-select":"MHASWgG4tM","userSelect":"MHASWgG4tM"};